/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Slobodan Djordjevic
 */
import React, { Component } from "react"
import { connect } from "react-redux"
import {
    Color,
    Column,
    Element,
    Label,
    Row,
    MomentPreview,
    sharedMomentToCZ,
    RoundButton,
    Icon,
} from "trux"
import {
    copy,
    facebookShare,
    getUtmCodes,
    isMobile,
    nativeShare,
    twitterShare,
} from "../../util/helpers"
import * as links from "../../util/links"
import { PreviewCard } from "trux/dist/organisms/PreviewCard"
import { DownloadMomentModal } from "../../components/DownloadMomentModal"
import "./StoryMoment.css"
import traceBotSad from "../../assets/img/tracebot_confused.svg"

const maxNoOfLoops = 5
const hashtags = "TraceMoments"

class StoryMomentComponent extends Component {
    state = {
        story: null,
        openPreview: false,
        item: null,
        showPlayIcon: true,
        isPlaying: false,
        message: "",
        downloadMomentModalOpen: false,
        showInfo: false,
        loadedStories: [],
        storyNumber: 0,
    }

    constructor(props) {
        super(props)
        this.childRef = React.createRef()
    }

    componentDidMount() {
        this.props.stories?.length && this.setRandomStory(this.props.stories)
    }

    componentDidUpdate(prevProps) {
        if (
            prevProps.loading !== this.props.loading &&
            this.props.stories?.length &&
            !this.state.story
        ) {
            this.setRandomStory(this.props.stories)
        }
    }

    setRandomStory = (stories) => {
        let story = stories[0]
        let moment = story.moment
        let item = this.transformMoment(moment)

        this.setState({ story: story, item: item, loadedStories: stories })
    }

    transformMoment = (moment) => {
        moment.meta.users.map((user, index) => {
            moment.meta.users[index].trace_number =
                moment.meta.trace_numbers[index]
        })

        return {
            dynamic_hls: moment.dynamic.hls,
            game_clip_id: moment.game_clip_id,
            game_id: moment.game_id,
            home_team: {
                name: moment.meta.home_team.id,
                title: moment.meta.home_team.name,
            },
            users: moment.meta.users,
        }
    }

    getCZShareEvent = (type) => {
        return {
            type: type,
            user_id: this.props.isLoggedIn ? this.props.user?.user_id : null,
            where: "main",
            moment_id: this.state.item.game_clip_id,
        }
    }

    onStoryClick = (e) => {
        this.state.story && this.setState({ openPreview: true })
        this.childRef.current.pause()
        this.setState({ showInfo: false })
    }

    onMomentClick = (e) => {
        let message = !this.state.isPlaying ? "Play" : "Paused"
        this.setState({
            showPlayIcon: false,
            message: message,
            isPlaying: !this.state.isPlaying,
        })
    }

    onShareClicked = (e) => {
        let text = `Watch this moment from Trace #${hashtags}`
        let gameLink =
            this.commonGameLink(this.state.item) +
            "?" +
            getUtmCodes("story", "share", "native")
        let isNativeShare =
            this.state.story &&
            nativeShare(gameLink, text, "trace", "share", "native-share")

        if (isNativeShare) {
            if (e) e.stopPropagation()

            if (this.state.item) {
                sharedMomentToCZ(this.getCZShareEvent("native share"))
            }
        }
    }

    goToTraceId = () => {
        if (this.state.item) {
            let link =
                links.GO_TRACEUP_COM +
                "/#" +
                links.gameUrl(
                    this.state.item.home_team?.name,
                    "goals",
                    this.state.item.game_id,
                    0
                ) +
                "/save/profile"
            Object.assign(document.createElement("a"), {
                target: "_blank",
                href: link,
            }).click()
        }
    }

    copyLink = (e) => {
        copy(e)
        if (this.state.item) {
            sharedMomentToCZ(this.getCZShareEvent("copy"))
        }
    }

    facebook = (e) => {
        let gameLink =
            this.commonGameLink(this.state.item) +
            "?" +
            getUtmCodes("story", "share", "facebook")
        if (this.state.item) {
            facebookShare(
                gameLink,
                this.props.isLoggedIn ? this.props.user?.user_id : null,
                this.state.item.game_clip_id,
                e.target
            )
        }
    }

    twitter = (e) => {
        let gameLink =
            this.commonGameLink(this.state.item) +
            "?" +
            getUtmCodes("story", "share", "twitter")
        if (this.state.item) {
            twitterShare(
                gameLink,
                this.props.isLoggedIn ? this.props.user?.user_id : null,
                this.state.item.game_clip_id,
                e.target
            )
        }
    }

    download = (e) => {
        this.setState({ downloadMomentModalOpen: true, openPreview: false })
    }

    sendEmail = (e) => {
        if (e) e.preventDefault()
        let link = this.gameEmailLink()
        Object.assign(document.createElement("a"), {
            target: "_blank",
            href: link,
        }).click()
        if (this.state.item) {
            sharedMomentToCZ(this.getCZShareEvent("email"))
        }
    }

    gameEmailLink = () => {
        let subject = `Great moment from Trace`

        let body = `Hi!`
        body += "\n"
        body += "\n"
        body += `Check out this great soccer moment from Trace: `
        body += "\n"
        body += "\n"
        body += window.location.href
        body += "\n"
        body += "\n"
        body += `Trace is an all-in-one game film system. Learn more about Trace: https://traceup.com`
        let encBody = encodeURIComponent(body)

        return `mailto:?BCC=sharingiscaring@traceup.com&Subject=${subject}&Body=${encBody}`
    }

    commonGameLink = (item) => {
        let moment = item.game_clip_id
            ? "C" + item.game_clip_id
            : "0"
        let playlist = item.users[0]?.trace_number
            ? `player-highlights-${item.users[0].trace_number}-game`
            : `touch-chains`
        return `${links.GO_TRACEUP_COM}${links.gameUrl(
            item.home_team.name,
            playlist,
            item.game_id,
            moment
        )}`
    }

    thisMoment = (e) => {
        if (e) e.preventDefault()
        if (this.state.item) {
            Object.assign(document.createElement("a"), {
                target: "_blank",
                href: this.state.story?.link,
            }).click()
        }
    }

    thisGame = (e) => {
        if (e) e.preventDefault()
        if (this.state.item) {
            let link =
                links.GO_TRACEUP_COM +
                "/#" +
                links.gameUrl(
                    this.state.item.home_team?.name,
                    "goals",
                    this.state.item.game_id,
                    0
                ) +
                "/choose"
            Object.assign(document.createElement("a"), {
                target: "_blank",
                href: link,
            }).click()
        }
    }

    changeLoopCount = (loopCount) => {
        loopCount > maxNoOfLoops && this.childRef.current.stop()
    }

    onVisibilityChange = (e) => {
        if (!isMobile()) {
            return
        }

        // intersectionRatio will be less than 1 since video is stretched
        if (e.event.intersectionRatio && e.action === "show") {
            e.video.play()
        } else {
            e.video.pause()
        }
    }

    onMouseEnter = (e) => {
        this.childRef.current.play()
        this.setState({ showInfo: true })
    }

    onMouseLeave = (e) => {
        this.childRef.current.pause()
        this.setState({ showInfo: false })
    }

    changeCard = (direction) => {
        if (direction === "back" && this.state.storyNumber > 0) {
            this.changeStory("back")
        }
        if (
            direction === "forward" &&
            this.state.storyNumber < this.state.loadedStories?.length - 1
        ) {
            this.changeStory("forward")
        }
    }

    changeStory = (direction) => {
        let newStoryNumber =
            direction === "back"
                ? this.state.storyNumber - 1
                : this.state.storyNumber + 1
        let selectedStory = this.state.loadedStories[newStoryNumber]
        let moment = selectedStory?.moment
        if (moment) {
            let item = this.transformMoment(moment)
            this.setState({
                storyNumber: newStoryNumber,
                item: item,
                story: selectedStory,
            })
        }
    }

    render() {
        let { loading, complete, isLoggedIn, user } = this.props
        let {
            story,
            item,
            downloadMomentModalOpen,
            storyNumber,
            loadedStories,
            openPreview,
        } = this.state
        let userId = isLoggedIn && user ? user.user_id : null
        let moment = {
            meta: { home_team: { id: item?.home_team.name } },
            game_id: item?.game_id,
            game_clip_id: item?.game_clip_id,
            dynamic_hls: item?.dynamic_hls,
        }

        return (
            <>
                {!loading && story && item && (
                    <Row
                        trkContext="Story Moment"
                        trkAction="Story Pressed"
                        className="stories-wrapper story-animation"
                        marginBottom="8"
                        alignItems="center"
                        onClick={(e) => this.onStoryClick(e)}
                        onMouseEnter={(e) => {
                            this.onMouseEnter(e)
                        }}
                        onMouseLeave={(e) => {
                            this.onMouseLeave(e)
                        }}
                    >
                        <Label
                            type={Label.Type.Body}
                            bold
                            className="stories-title"
                            content={story.title}
                            spacing="4"
                        />
                        <Column className="story-preview">
                            <Row className="stories-moment">
                                {moment.dynamic_hls && (
                                    <MomentPreview
                                        ref={this.childRef}
                                        event={moment}
                                        sources={[moment]}
                                        noHoverPlay={true}
                                        playbackRate={2}
                                        userId={userId}
                                        utmCampaign={"StoryMoment"}
                                        changeLoopCount={(loopCount) =>
                                            this.changeLoopCount(loopCount)
                                        }
                                        onVisibilityChange={(e) =>
                                            this.onVisibilityChange(e)
                                        }
                                        showProgressBar={this.state.showInfo}
                                        trackingPlayerType="Mini"
                                        trackingAction={this.props.trackingAction}
                                    />
                                )}
                            </Row>
                        </Column>
                    </Row>
                )}
                {!loading && complete && !story && (
                    <Column
                        className={"story-animation"}
                        justifyContent="center"
                        alignItems="center"
                        marginBottom="8"
                    >
                        <img
                            src={traceBotSad}
                            alt="sad-story"
                            className="trace-bot-confused-story"
                        />
                        <Label
                            type={Label.Type.Body}
                            color={Color.Grey1}
                            content={"No moments right now."}
                        />
                    </Column>
                )}
                {!loading && story && item && (
                    <Element>
                        <Element className="left-arrow" span={1}>
                            {openPreview && storyNumber > 0 && (
                                <RoundButton
                                    trkAction="Previous Pressed"
                                    icon={Icon.Type.CheveronLeft}
                                    color={Color.White2}
                                    iconSize={16}
                                    size={36}
                                    onClick={() => this.changeStory("back")}
                                />
                            )}
                        </Element>
                        <PreviewCard
                            key={item.game_clip_id}
                            open={openPreview}
                            onPreviewClose={() =>
                                this.setState({ openPreview: false })
                            }
                            item={item}
                            traceIdButton
                            onMomentClick={(e) => this.onMomentClick(e)}
                            showPlayIcon={this.state.showPlayIcon}
                            message={this.state.message}
                            onShareClicked={(e) => this.onShareClicked(e)}
                            goToTraceId={() => this.goToTraceId()}
                            copyLink={(e) => this.copyLink(e)}
                            facebook={(e) => this.facebook(e)}
                            twitter={(e) => this.twitter(e)}
                            download={(e) => this.download(e)}
                            sendEmail={(e) => this.sendEmail(e)}
                            thisMoment={(e) => this.thisMoment(e)}
                            thisGame={(e) => this.thisGame(e)}
                            changeCard={(value) => this.changeCard(value)}
                            className={"preview-card-component"}
                            trackingAction={this.props.trackingAction}
                        >
                            <Row
                                marginTop="8"
                                marginBottom="8"
                                className="stories-content"
                            >
                                <Label
                                    type={Label.Type.Body}
                                    color={Color.Black}
                                    bold
                                    content={story.title}
                                    className="stories-content-text"
                                    marginTop="4"
                                    marginBottom="2"
                                    marginLeft="4"
                                    marginRight="4"
                                />
                                <Label
                                    type={Label.Type.SmallBody}
                                    color={Color.Grey1}
                                    content={story.description}
                                    className="stories-content-text"
                                    marginBottom="4"
                                    marginLeft="4"
                                    marginRight="4"
                                />
                            </Row>
                        </PreviewCard>
                        <Element className="right-arrow" span={1}>
                            {openPreview &&
                                storyNumber < loadedStories?.length - 1 && (
                                    <RoundButton
                                        trkAction="Next Pressed"
                                        icon={Icon.Type.CheveronRight}
                                        color={Color.White2}
                                        iconSize={16}
                                        size={36}
                                        onClick={() =>
                                            this.changeStory("forward")
                                        }
                                    />
                                )}
                        </Element>
                        <textarea
                            readOnly
                            id="copy-link"
                            style={{
                                height: "1px",
                                width: "1px",
                                position: "absolute",
                                top: "-999px",
                                left: "-999px",
                            }}
                            value={
                                this.commonGameLink(item) +
                                "?" +
                                getUtmCodes("story", "share", "link")
                            }
                        />
                    </Element>
                )}
                {downloadMomentModalOpen && (
                    <DownloadMomentModal
                        downloadMomentModalOpen={downloadMomentModalOpen}
                        setDownloadMomentModalOpen={(isOpen) =>
                            this.setState({ downloadMomentModalOpen: isOpen })
                        }
                        item={item}
                    />
                )}
            </>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        stories: state.stories.value,
        loading: state.stories.loading,
        complete: state.stories.complete,
        isLoggedIn: state.isLoggedIn,
        team: state.team.value,
        user: state.user.value,
    }
}

const StoryMoment = connect(mapStateToProps, null)(StoryMomentComponent)
export default StoryMoment
